// prettier-ignore
export const IS_POPUP_VAR = "_popup" as const
export const JSON_REDIRECT_CONTENT_TYPE = "application/json+redirect" as const
export const PARSABLE_COMMENT = "<!-- parsable-page-e1616a74-f29e-482c-b467-3c3f40dd05d6 -->" as const
export const FILECHECK_PREFIX = "filecheck" as const
export const IMPOSITION_PREFIX = "imposition" as const
export const FILEMETA_SPLIT_CHARACTER = "@" as const
export const FILEDISPATCH_SPLIT_CHARACTER = "~" as const
export const SESSION_PARAMETERS = {
    "email": "@",
    "id": "id",
    "is_staff": "is",
    "name": "fn",
    "cart_counter": "k",
    "signup_time": "sg",
    "has_discount": "d"
} as const
export const INLINE_FILE_EXTENSIONS = [
    "bmp",
    "gif",
    "jpeg",
    "jpg",
    "mp4",
    "png",
    "svg",
    "webp"
] as const
export const IMAGE_CONTENT_TYPES = {
    ".png": "image/png",
    ".jpeg": "image/jpeg",
    ".jpg": "image/jpeg",
    ".gif": "image/gif",
    ".svg": "image/svg+xml",
    ".pdf": "application/pdf",
    ".bmp": "image/bmp"
} as const
export const SWITCH_FILE_PREPRESS = "Macchine/Xerox Ciano FR" as const
export const SWITCH_DEFAULT_CHOICE = "Router/digitale" as const
export const DEFAULT_FILE_BLEED = 5000 as const
export const DEFAULT_STROKE_WIDTH = 100 as const
export const DEFAULT_IMAGE_RESOLUTION = 300 as const
export const SESSION_COOKIE_NAME = "accountid" as const
export const SPLIT_CHARACTER = "." as const
export const BUNDLE_FOLDER_NAME = "x" as const
export const VERSION = "2026.0323.0627" as const
export const ENTRY_POINTS = {
    "rotostampa/app.js": "rotostampa",
    "sprint24/app.js": "sprint24",
    "letterpress/app.js": "letterpress",
    "splendo/app.js": "splendo",
    "bigliettiuv/app.js": "bigliettiuv"
} as const
export const STATIC_URL = "/file/or/s/-/" as const